import Box from "@mui/material/Box";
import { GridColDef } from "@mui/x-data-grid";
import BookmarkPlan from "components/common/Bookmark";
import { StyledLink } from "components/common/Table";
import { store } from "redux/store";
import { tokens } from "styles/Tokens";
import { abovePropertyViewTypeProperty } from "utils/CommonConstants";
import { engagementTypes } from "utils/Types";

export const getColor = (status: string) => {
  let color = tokens.Text.Feedback.Alert;
  if (status === engagementTypes.active) {
    color = tokens.Text.Feedback.Done;
  }
  if (status === engagementTypes.overdue) {
    color = tokens.Text.Feedback.Overdue;
  }
  return color;
};

export const headers: GridColDef[] = [
  {
    field: "propertyName",
    headerName: "Property",
    sortable: false,
    flex: 1,
    minWidth: 200,
    renderCell: (params: any) => {
      return <StyledLink to={`/property/${params?.id}?parentTab=Property+Plans`}>{params.value}</StyledLink>;
    }
  },
  { field: "innCode", headerName: "Inncode", sortable: false, width: 100 },
  { field: "brandName", headerName: "Brand", sortable: false, flex: 1, minWidth: 200 },
  { field: "leaderPlans", headerName: "Leader Plans", sortable: false, width: 120 },
  { field: "teamPlans", headerName: "Team Plans", sortable: false },
  {
    field: "engagement",
    headerName: "Engagement",
    sortable: false,
    width: 120,
    renderCell: (params: any) => {
      return (
        <Box component="span" sx={{ color: getColor(params.value) }}>
          {params.value ?? "-"}
        </Box>
      );
    }
  },
  {
    field: "bookmarkAction",
    headerName: "",
    sortable: false,
    renderCell: (params: any) => {
      const { bookmarkedProperties } = store.getState().aboveProperty;
      const isBookmarked = bookmarkedProperties?.some((b: any) => b?.innCode === params?.id);

      return (
        <BookmarkPlan
          aboveUserPayload={{
            isAboveUsertype: true,
            viewType: abovePropertyViewTypeProperty,
            inncode: params?.id
          }}
          isBookmarked={isBookmarked}
        />
      );
    }
  }
];
